<nav class="toolbar navbar navbar-light">
    <form class="form-inline" autocomplete="off">
        <!--<button class="btnback btn btn-outline-success"><i class="fa fa-chevron-left"></i></button>-->
        <button *ngIf="!visibilitySpinner" type="button" class="btn btn-outline-success" (click)="onExportExcel()" title="Exportar"><i class="fa fa-file-excel-o"></i> Exportar </button>
        <button *ngIf="visibilitySpinner" type="button" [disabled]="true" class="btn btn-outline-success">
            <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
            Exportando
        </button>
    </form>
</nav>

<form [formGroup]="form" class="container-fluid" autocomplete="off">
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-md-12">
                <h4>Buscador Envíos de Documentos a Traces</h4>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">

                <div class="card card-accent-success animated fadeIn">
                    <a class="card-header-a" (click)="isCollapsed = !isCollapsed"
                       [attr.aria-expanded]="!isCollapsed" aria-controls="collapseExample">
                        <div class="card-header-buscador">
                            <i class="fa fa-filter"></i> Filtros
                            <i *ngIf="isCollapsed" class="fa fa-caret-down float-right"></i>
                            <i *ngIf="!isCollapsed" class="fa fa-caret-up float-right"></i>
                        </div>
                    </a>

                    <div class="card-body">
                        <!-- Ocultamos solo los campos, para que estén siempre visibles los botones "Buscar y Limpiar" -->
                        <div class="collapse group-filtros" id="collapseFiltros" [ngbCollapse]="isCollapsed">

                            <div class="row">

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="inpCodigo">Id Solicitud</label>
                                    <input formControlName="IdSolicitud" numbersOnly name="IdSolicitud" title=""
                                           class="form-control" id="inpNombre" type="text" value="" maxlength="9">
                                </div>

                                <div class="form-group col-md-3">
                                    <label for="time" class="col-form-label" for="inpFecha">Fecha y Hora Desde</label>
                                    <p-calendar formControlName="FechaDesde" [showTime]="true" [showSeconds]="true" inputId="time" inputStyleClass="form-control" [showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy"></p-calendar>
                                </div>

                                <div class="form-group col-md-3">
                                    <label for="time" class="col-form-label" for="inpFecha">Fecha y Hora Hasta</label>
                                    <p-calendar formControlName="FechaHasta" [showTime]="true" [showSeconds]="true" inputId="time" inputStyleClass="form-control" [showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy"></p-calendar>
                                </div>

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="intEstado">Estado Solicitud</label>
                                    <ng-select loadingText="Cargando..."
                                               [items]="listEstadoSolicitud"
                                               bindLabel="Descripcion"
                                               bindValue="Id"
                                               formControlName="IdEstadoSolicitud"
                                               [loading]="!listEstadoSolicitud"
                                               notFoundText="Estado no encontrado"
                                               placeholder="-- Seleccione un Estado --"
                                               clearAllText="Eliminar selección">
                                    </ng-select>
                                </div>

                            </div>

                            <div class="row">

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="inpCodigo">Código Solicitud</label>
                                    <input formControlName="CodigoSolicitud" name="CodigoSolicitud" title="" class="form-control"
                                           inputStyleClass="form-control" id="inpCodigoSolicitud" maxlength="50" type="text" value="">
                                </div>

                                <div class="form-group col-md-3">
                                    <label class="col-form-label" for="inpDescripcion">CHED PP</label>
                                    <input formControlName="ChedPp" name="ChedPp" title="" class="form-control" inputStyleClass="form-control"
                                           id="inpChedPp" maxlength="50" type="text" value="">
                                </div>

                                <div class="form-group col-md-6">
                                    <label class="col-form-label" for="intTipoDocumento">Tipo de Documento</label>
                                    <ng-select loadingText="Cargando..."
                                               [items]="listTipoDocumento"
                                               bindLabel="Descripcion"
                                               bindValue="Id"
                                               formControlName="IdTipoDocumento"
                                               [loading]="!listTipoDocumento"
                                               notFoundText="Documento no encontrado"
                                               placeholder="-- Seleccione un Documento --"
                                               clearAllText="Eliminar selección">
                                    </ng-select>
                                </div>

                            </div>

                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group-0 float-right">

                                    <div class="btn-group">
                                        <button name="btnSearch" class="btn btn-secondary btn-sm" type="submit" title="Realiza una búsqueda"
                                                (click)="onSearchButton()">
                                            <i class="fa fa-search"></i> Buscar
                                        </button>
                                    </div>

                                    <div class="btn-group">
                                        <button class="btn btn-secondary btn-sm" type="button" title="Limpia los filtros" (click)="onCleanButton()">
                                            <i class="fa fa-eraser"></i> Limpiar
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>


        <!--DATAGRID-->

        <div *ngIf="searchingButton" class="row">
            <div class="col-md-12">
                <div class="card card-accent-success">
                    <div class="card-header-buscador">
                        <i class="fa fa-align-justify"></i> Listado de Envíos de Documentos a Traces
                    </div>

                    <div class="card-body-grid">

                        <p-table #tableSearch autoLayout="true" [value]="resultEnvioDocumentoTraces?.ResultList" [lazy]="true" (onLazyLoad)="onSearchLazy($event)" [paginator]="true"
                                 [columns]="cols" sortField="FechaFin" sortOrder="-1" [rows]="resultEnvioDocumentoTraces?.PageSize" [totalRecords]="resultEnvioDocumentoTraces?.TotalCount" [loading]="loading"
                                 styleClass="table table-responsive-sm  table-striped table-sm" [ngClass]="displayGridHidden(resultEnvioDocumentoTraces?.ResultList)">
                            <ng-template pTemplate="header" let-columns>
                                <tr>
                                    <th scope="col" *ngFor="let col of columns" [ngStyle]="{'display': col.display}" [pSortableColumn]="col.field">
                                        {{col.header}}
                                        <p-sortIcon *ngIf="col.field!=='Link'" [field]="col.field"></p-sortIcon>
                                    </th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
                                <tr>
                                    <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">
                                        <span *ngIf="(col.field!=='Link' && col.field!=='Duracionms')">{{ rowData[col.field] }}</span>
                                        <span class="pull-right" *ngIf="(col.field!=='Link' && col.field==='Duracionms')">{{ rowData[col.field] }}</span>
                                        <div *ngIf="col.field==='Link'" class="btn-group">
                                            <button (click)="onView(rowData)" type="button" title="Ver detalle"
                                                    class="btn btn-sm btn-info">
                                                <span class="fa fa-search"></span>
                                            </button>

                                            <div *ngIf="checkToSend(rowData)">
                                                <button (click)="onSend(rowData)" type="button" title="Enviar"
                                                        class="btn btn-sm btn-warning">
                                                    <span class="fa fa-paper-plane"></span>
                                                </button>
                                            </div>
                                        </div>
                                    </td>
                                </tr>

                            </ng-template>
                        </p-table>

                        <div class="p-2" *ngIf="tableSearch?.totalRecords">Se han encontrado {{ tableSearch?.totalRecords  | number:'1.0-0':'es-ES' }} registros</div>
                        <div class="empty-grid" *ngIf="tableSearch?.totalRecords === 0">No se ha encontrado ningún registro</div>

                    </div>

                </div>
            </div>
        </div>
    </div>

</form>
